module.exports = __webpack_public_path__ + "img/1546030749.98badb57.jpg";